import axiosService from "../axios-util/axios-services";

export type LoginRequestBody = { email: string; password: string };
export type UserBody = {name: string; nickname: string;
email: string;
role: string;
id_kind: string;
version: string;
client_id:string;
image: string;
mebuku_id: string; };

export type User = {
	user_id: any;
	key: string;
	email: string;
}

const loginWithToken = async (): Promise<any> => {
	try {
		const response = await axiosService.get(`users/find_by_token`);
		return response
	} catch (error) {
		return error
	}
}

const updateAppUser = async (userId:any, body: any) => {
	const response = await axiosService.put(`users/${userId}`, body);
	return response
}

const authService = {
	loginWithToken,
	updateAppUser,
};

export default authService;